import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GeneralConstants } from 'app/constants';
import { CrisRequestType } from 'app/constants/cris-request-type';
import { MidTuple, ListOptions, PatternData } from 'app/model';
import { AsyncSearchResponse } from 'app/model/es/async-search.response';
import { MidFilter } from 'app/model/mid-filter';
import { BaseApiService } from 'app/services/base-api.service';

class MLSearchService extends BaseApiService {
    public findTuples(
        searchParams: PatternData,
        filters: MidFilter[],
        correction?: string,
        storeField?: boolean,
        storeId?: number,
        searchAfter?: Array<number | string>,
        opts?: ListOptions,
        sampleId?: number,
        isNegative?: boolean,
        isTagStore?: boolean,
    ): Observable<AsyncSearchResponse<MidTuple>> {
        const { extraParams, ...rest } = opts ?? {};
        const httpOpts = {
            params: {
                ...extraParams,
                ...rest,
            },
        };

        const options = {
            samples_search: {
                type: CrisRequestType.STORE,
                searchParams,
                correction,
                storeField,
                storeId,
                searchAfter,
                filters,
                sampleData: sampleId ?? GeneralConstants.COMPONENT_VALUE_NULL,
                isNegative,
                isTagStore,
            },
        };

        return this.http
            .post<AsyncSearchResponse<MidTuple>>(this.getAbsolutePath('ml/search/mids'), options, httpOpts)
            .pipe(map((response) => new AsyncSearchResponse<MidTuple>(response)));
    }

    public asyncResults<T>(id: string): Observable<AsyncSearchResponse<T>> {
        return this.http
            .get<AsyncSearchResponse<T>>(this.getAbsolutePath('search/async/results'), { params: { id } })
            .pipe(map((response) => new AsyncSearchResponse<T>(response)));
    }
}

export const mlSearchService = new MLSearchService();
